/** Success wrapper for boolean plugin responses. */
export const successResponse = () => ({ value: true });
/** Failure wrapper for boolean plugin responses. */
export const failureResponse = () => ({ value: false });
/** Error for missing microphone permission. */
export const missingPermissionError = () => new Error('MISSING_PERMISSION');
/** Error for attempting to start while already recording. */
export const alreadyRecordingError = () => new Error('ALREADY_RECORDING');
/** Error for microphone in use by another app or recorder. */
export const microphoneBeingUsedError = () => new Error('MICROPHONE_BEING_USED');
/** Error for devices that cannot record audio. */
export const deviceCannotVoiceRecordError = () => new Error('DEVICE_CANNOT_VOICE_RECORD');
/** Error for recorder start failures. */
export const failedToRecordError = () => new Error('FAILED_TO_RECORD');
/** Error for empty or zero-length recordings. */
export const emptyRecordingError = () => new Error('EMPTY_RECORDING');
/** Error for stopping without an active recording. */
export const recordingHasNotStartedError = () => new Error('RECORDING_HAS_NOT_STARTED');
/** Error for failures when fetching recording data. */
export const failedToFetchRecordingError = () => new Error('FAILED_TO_FETCH_RECORDING');
/** Error for browsers that do not support permission queries. */
export const couldNotQueryPermissionStatusError = () => new Error('COULD_NOT_QUERY_PERMISSION_STATUS');
//# sourceMappingURL=predefined-web-responses.js.map